import React, { useState } from 'react';
import axios from 'axios';
import { CreditCard, CheckCircle } from 'lucide-react';

export default function OrderPaymentSummary({ order, token }) {
  const [paying, setPaying] = useState(false);
  const [error, setError] = useState('');
  const money = (value) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value || 0);
  const paid = order.payment_status === 'Paid in Full' && !order.payment_review_required;
  const pay = async () => {
    setPaying(true);
    setError('');
    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/payments/checkout`, {
        order_id: order.id, origin_url: window.location.origin,
      }, { headers: { Authorization: `Bearer ${token}` } });
      window.location.assign(response.data.url);
    } catch (err) {
      setError(err.response?.data?.detail || 'We couldn’t open checkout. Please try again.');
      setPaying(false);
    }
  };
  return (
    <section aria-label="Order payment" className="mt-4 border-t border-gray-100 pt-4 text-sm" data-testid={`order-payment-${order.id}`}>
      <div className="flex flex-wrap justify-between gap-2 font-semibold text-[#1B3A5C]">
        <span>Payment</span>
        <span className={paid ? 'text-green-700 inline-flex items-center gap-1' : ''}>
          {paid && <CheckCircle className="h-4 w-4" aria-hidden="true" />}{order.payment_status || 'Unpaid'}
        </span>
      </div>
      {!order.payment_review_required && <div className="mt-2 space-y-1 text-gray-600">
        <div className="flex justify-between gap-3"><span>Paid to date</span><span>{money(order.amount_paid)}</span></div>
        <div className="flex justify-between gap-3 font-semibold text-[#1B3A5C]"><span>Balance due</span><span>{money(order.balance_due)}</span></div>
      </div>}
      {order.payment_review_required && <p className="mt-2 text-gray-600">Our team is confirming your balance. Please contact us if you need help.</p>}
      {order.can_pay && <button onClick={pay} disabled={paying}
        className="mt-3 flex min-h-[44px] w-full items-center justify-center gap-2 rounded-lg bg-[#1B3A5C] px-4 py-3 font-semibold text-white hover:bg-[#264d76] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1B3A5C] disabled:opacity-60">
        <CreditCard className="h-4 w-4" aria-hidden="true" />{paying ? 'Opening secure checkout…' : `Pay balance — ${money(order.balance_due)}`}
      </button>}
      {error && <p role="alert" className="mt-2 text-red-700">{error}</p>}
    </section>
  );
}
